import {Card, CardActionArea, CardContent, Chip, Stack, styled, Typography} from '@mui/material'
import {shuffle} from 'lodash'
import {useCallback, useMemo} from 'react'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates'
import {useChatContext} from './ChatContext'
import type {ConversationStarter} from '@goschool/model'
import {isAdvancedConversationStarter} from '@goschool/model'

export function ConversationStarters() {
  const {conversationStarters} = useChatContext()

  const selected = useMemo(
    () => shuffle(conversationStarters ?? []).slice(0, 4),
    [conversationStarters]
  )

  if (conversationStarters == null) {
    return null
  }

  return <Stack direction="row" justifyContent="center" gap={2} rowGap={2} px={4} flexWrap="wrap">
    {selected.map((starter, i) =>
      <ConversationStarterChip key={i} starter={starter}/>
    )}
  </Stack>

}


function ConversationStarterChip({starter}: { starter: ConversationStarter }) {
  const {chatManager} = useChatContext()

  const sendMessage = useCallback(
    (message: string) => () => chatManager.post(message),
    [chatManager]
  )
  const [title, message] = useMemo(
    () => isAdvancedConversationStarter(starter)
      ? [starter.title, starter.message]
      : [starter, starter],
    [starter]
  )

  return <ConversationStarterStyleChip
    variant="outlined" icon={<TipsAndUpdatesIcon fontSize="small" color="info"/>} label={title}
    onClick={sendMessage(message)}/>
}

const ConversationStarterStyleChip = styled(Chip, {name: 'ConversationStarterStyleChip'})(
  ({theme}) => ({
    '& .MuiChip-label': {
      maxWidth: '30rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  })
)

function ConversationStarterCard({starter}: { starter: ConversationStarter }) {
  const {chatManager} = useChatContext()

  const sendMessage = useCallback(
    (message: string) => () => chatManager.post(message),
    [chatManager]
  )
  const [title, message] = useMemo(
    () => typeof starter === 'string'
      ? [starter, starter]
      : [starter.title, starter.message],
    [starter]
  )

  return <Card>
    <CardActionArea onClick={sendMessage(message)}>
      <CardContent sx={{height: '6rem'}}>
        <Typography variant="body2">{title}</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
}
